import config from "@Config/index";
import axios from "axios";

const fetchOffers = async ({
  id,
  token,
  selectedLang,
  userCurrency,
  internalUser,
  isWhitelabel,
  partnerId,
}: any) => {
  const optionHeaders: any = {
    headers: {
      ...(config.IS_CHINA_APP ? {} : { "X-Use-Java-Api": "true" }),
    },
  };
  const language = selectedLang;

  if (!__CLIENT__) {
    optionHeaders.headers = {
      ...optionHeaders.headers,
      Cookie: `user_auth_token=${token}`,
    };
  }

  const params = {
    ...config.apiParams,
    lang: language || "en",
    use_java_api: true,
    ...(userCurrency ? { user_currency: userCurrency } : {}),
    ...(internalUser ? { is_internal_user: internalUser } : {}),
    ...(isWhitelabel ? { is_whitelabel: true } : {}),
    ...(partnerId ? { partner_id: partnerId } : {}),
  };

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}/offers`, {
    ...optionHeaders,
    params,
    withCredentials: true,
  });
};

export default fetchOffers;
